var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
import { ExtraItemWithoutRelationsDto } from '../../../classes/extra-item';
export class ReservationExtraItemDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.extraItemId = initializer.extraItemId;
        this.quantity = initializer.quantity;
        this.fee = initializer.fee;
        this.directPaymentPrice = initializer.directPaymentPrice;
        this.memo = initializer.memo;
        this.extraItem = initializer.extraItem;
    }
}
__decorate([
    Type(() => ExtraItemWithoutRelationsDto),
    __metadata("design:type", ExtraItemWithoutRelationsDto)
], ReservationExtraItemDto.prototype, "extraItem", void 0);
